import n from "compressorjs";
import { MAX_FILE_SIZE_MB as l } from "../constants.js";
const m = (t, e) => {
  const r = t.target.files?.[0];
  if (!r) return;
  if (!r.type.startsWith("image/")) {
    alert("Please upload an image file (JPEG, PNG, etc.)");
    return;
  }
  const o = r.size / (1024 * 1024);
  if (o > l) {
    alert(`File size exceeds ${l}MB limit. Please upload a smaller or optimized image file.`);
    return;
  }
  e.setName(r.name), e.setSize(o), new n(r, {
    quality: 0.7,
    convertTypes: ["image/png", "image/webp"],
    convertSize: 1e6,
    success(a) {
      const i = a, s = new FileReader();
      s.onloadend = () => {
        e.setPreviewUrl(s.result);
      }, s.readAsDataURL(i), e.setName(r.name);
    },
    error(a) {
      console.error("Compression failed:", a.message);
      const i = new FileReader();
      i.onloadend = () => {
        e.setPreviewUrl(i.result);
      }, i.readAsDataURL(r);
    }
  });
}, p = (t) => `${t.toFixed(2)} MB`, f = (t) => (e) => {
  m(e, t);
};
export {
  f as createFileChangeHandler,
  p as getFileSizeString,
  m as handleFileSelect
};
